import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ServerCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-server-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 14.5v1.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 20v1.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21.032 16.25l-1.299 .75"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16.27 19l-1.3 .75"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.97 16.25l1.3 .75"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.733 19l1.3 .75"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 8v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 16v.01"
    }, null), _createTextVNode(" ")]);
  }
};